export const DOCUMENT_TYPES = ["ID_CARD", "PASSPORT"] as const;
export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export const INCOME_SOURCES = [
  "BUSINESS_ACTIVITY",
  "INVESTMENTS",
  "MAINTAINED_BY_FAMILY",
  "OTHER",
  "SALARY",
  "SOCIAL_BENEFITS",
  "TENANCY",
] as const;
export type IncomeSource = (typeof INCOME_SOURCES)[number];

export const OCCUPATIONS = [
  "ADMINISTRATION_AND_OFFICE_MANAGEMENT",
  "ARTS_AND_DESIGN",
  "CONSTRUCTION_AND_TRADES",
  "CUSTOMER_SERVICE",
  "EDUCATION_AND_TEACHING",
  "ENGINEERING",
  "FINANCE_AND_ACCOUNTING",
  "HEALTHCARE_AND_MEDICAL_SERVICES",
  "HUMAN_RESOURCES",
  "IT",
  "LEGAL_SERVICES",
  "MANUFACTURING_AND_PRODUCTION",
  "RETAIL_AND_SALES",
  "SALES_AND_MARKETING",
  "SCIENCE_AND_RESEARCH",
] as const;
export type Occupation = (typeof OCCUPATIONS)[number];

export const OPEN_ACCOUNT_REASONS = [
  "CURRENCY_EXCHANGE",
  "DAILY_USE",
  "GAMING_OR_GAMBLING",
  "INVESTMENTS_OR_CRYPTOCURRENCIES",
  "TRANSFER_OF_FUNDS_OUTSIDE_OF_EUROPE",
] as const;
export type OpenAccountReason = (typeof OPEN_ACCOUNT_REASONS)[number];

export type KycSetupRequest = {
  documentType: DocumentType;
  country: string;
  incomeSource: IncomeSource;
  openAccountReason: OpenAccountReason;
  phone: string;
  street: string;
  number: string;
  city: string;
  postCode: string;
  citizenship: string;
  nationality: string;
  birthCountry: string;
  birthDate: string;
  occupation?: Occupation;
  taxId?: string;
  additionalInfo?: string;
  isPep: boolean;
  isFatca: boolean;
};

export type KycSetupResponse = {
  verificationId: string;
  redirectUrl: string | null;
  isProfileComplete: boolean;
  kyc: {
    status: "NOT_VERIFIED" | "VERIFIED" | "EXPIRED" | string;
    attemptStatus:
      | "CREATED"
      | "PENDING"
      | "REJECTED"
      | "REJECTED_BY_PROVIDER"
      | "REJECTED_BY_RISK"
      | "VERIFICATION"
      | "SUCCESSFUL"
      | string
      | null;
    rejectionReason?: string | null;
  } | null;
};

export type RetryKycRequest = {
  documentType: DocumentType;
  country: string;
  incomeSource: IncomeSource;
  openAccountReason: OpenAccountReason;
  occupation?: Occupation;
};

export type RetryKycResponse = {
  verificationId: string;
  redirectUrl: string;
  kyc: {
    status: "NOT_VERIFIED" | "VERIFIED" | "EXPIRED" | string;
    attemptStatus:
      | "CREATED"
      | "PENDING"
      | "REJECTED"
      | "REJECTED_BY_PROVIDER"
      | "REJECTED_BY_RISK"
      | "VERIFICATION"
      | "SUCCESSFUL"
      | string
      | null;
  } | null;
};
